export function fetchJobs(BeURL, keyword, location, currentPage, setCurrentPage, recordsPerPage, setRecordsPerPage, setTotalItems, setTotalPages, setJobs, showAlert) {

    fetch(`${BeURL}/fetch-jobs?keyword=${keyword}&location=${location}&page=${currentPage}&perPage=${recordsPerPage}`, {
        credentials: "include"
    })
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            const { currentPage, perPage, totalPages, totalCount } = data.pagination
            setJobs(data.jobs)
            setCurrentPage(currentPage)
            setRecordsPerPage(perPage)
            setTotalItems(totalCount)
            setTotalPages(totalPages)
            console.log("fethc job api success : ", data.jobs)
        }
        else {
            showAlert(data.message)
            console.log("fetch job api: " , data.message)
        }
    })
    .catch(err => {
        console.log("Erron in fetching User:", err)
        showAlert("Trouble in connecting to the Server, please try again later.")
    })
}

export function fetchProfileData(BeURL, id, setUser, showAlert) {
    fetch(`${BeURL}/fetch-profile-data`, {
        credentials: "include",
        method: "post",
        headers: {
            "Content-Type": "Application/json",
            Accept: "Application/json",
        },
        body: JSON.stringify({ id })
    })
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            setUser(data.user)
        }
        else {
            showAlert(data.message)
            console.log("fetch profile data  api: " , data.message)
        }
    })
    .catch(err => {
        console.log("Erron in fetching User:", err)
        alert("Trouble in connecting to the Server, please try again later.")
    })
}